/* sr-home-w2: progressive enhancement for the W2-style homepage. Without it the page still reads
   and works: the hero shows its poster, the rows scroll by swipe or keyboard. */
(function () {
  function init() {
    var root = document.querySelector('.srw');
    if (!root) { return; }
    document.documentElement.classList.add('srw-js');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* ---------- Rows below the fold (2026-10-25): previous and next ----------
       Each row scrolls inside itself (swipe, trackpad, keyboard). On a pointer device the edge
       buttons step one screenful of cards and only show while the row can move that way. */
    Array.prototype.forEach.call(root.querySelectorAll('.srw-row__rail'), function (rail) {
      var row = rail.querySelector('.srw-row__track');
      var prev = rail.querySelector('[data-dir="-1"]'), next = rail.querySelector('[data-dir="1"]');
      if (!row || !prev || !next) { return; }
      function step() {
        var card = row.firstElementChild;
        var gap = parseFloat(getComputedStyle(row).columnGap) || 16;
        var w = card ? card.getBoundingClientRect().width + gap : row.clientWidth * .8;
        var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
        return Math.max(w, Math.floor((row.clientWidth - 2 * pad + gap) / w) * w);
      }
      function update() {
        var max = row.scrollWidth - row.clientWidth;
        prev.hidden = row.scrollLeft <= 2;
        next.hidden = max <= 2 || row.scrollLeft >= max - 2;
      }
      rail.addEventListener('click', function (e) {
        var b = e.target.closest('.srw-row__btn');
        if (!b) { return; }
        row.scrollBy({ left: step() * Number(b.getAttribute('data-dir')), behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });

    /* ---------- Card previews (2026-10-25) ----------
       Pointer devices only: resting on a card for 400 ms lifts it and starts a short, muted loop of the
       case's step film over its poster (fetched on that first hover, never before). Phones, reduced
       motion and Save-Data never fetch a film; a refused play() (Low Power Mode) leaves the poster. */
    (function () {
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      var save = navigator.connection && navigator.connection.saveData;
      Array.prototype.forEach.call(root.querySelectorAll('.srw-card, .srw-feat[data-film]'), function (card) {
        var box = card.querySelector('.srw-card__art, .srw-feat__art'), film = card.getAttribute('data-film');
        var t = 0, v = null, dead = false;
        function enter() {
          if (!fine.matches) { return; }
          clearTimeout(t);
          t = setTimeout(function () {
            card.classList.add('is-hot');
            if (!film || dead || reduce.matches || save || !box) { return; }
            if (!v) {
              v = document.createElement('video');
              v.className = 'srw-film'; v.muted = true; v.loop = true; v.playsInline = true;
              v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true'); v.tabIndex = -1; v.preload = 'auto';
              v.addEventListener('playing', function () { if (card.classList.contains('is-hot')) { v.classList.add('is-on'); } });
              v.addEventListener('error', function () { dead = true; if (v && v.parentNode) { v.parentNode.removeChild(v); } v = null; });
              v.src = film; box.appendChild(v);
            }
            var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
          }, 400);
        }
        function leave() {
          clearTimeout(t); card.classList.remove('is-hot');
          if (v) { v.pause(); v.classList.remove('is-on'); }
        }
        card.addEventListener('mouseenter', enter);
        card.addEventListener('mouseleave', leave);
      });
    })();

    /* The client wall moved into the Client words row (#client-words); an old link to #client-reviews lands there. */
    if (location.hash === '#client-reviews') {
      var cw = document.getElementById('client-words');
      if (cw) { setTimeout(function () { cw.scrollIntoView({ block: 'start' }); }, 60); }
    }

    /* ---------- Hero film ----------
       Muted, looping, plays only while on screen. Reduced motion and data saver never fetch a
       video byte: the poster is a frame of the work. The pause control is always offered while
       the film runs (WCAG 2.2.2). */
    /* ---------- Phone dock clearance ----------
       The theme's fixed gold dock covers the bottom of a phone screen. Its real footprint
       (height plus its gap from the bottom edge) feeds --srw-dock, the extra foot room on bands. */
    function measureDock() {
      var dock = document.querySelector('.sr-mobile-dock');
      if (!dock) { return; }
      var cs = getComputedStyle(dock);
      if (cs.display === 'none' || cs.position !== 'fixed') { return; }
      var gap = parseFloat(cs.bottom) || 0;
      var h = Math.ceil(dock.getBoundingClientRect().height + gap + 12);
      if (h > 30 && h < 160) { root.style.setProperty('--srw-dock', h + 'px'); }
    }
    /* the dock is hidden until the visitor scrolls, so keep trying on scroll until it has a size */
    var dockDone = false, df = 0;
    function tryDock() { if (!dockDone) { measureDock(); dockDone = !!root.style.getPropertyValue('--srw-dock'); } }
    tryDock();
    window.addEventListener('load', tryDock);
    window.addEventListener('resize', function () { dockDone = false; tryDock(); }, { passive: true });
    document.addEventListener('scroll', function () {
      if (!dockDone && !df) { df = requestAnimationFrame(function () { df = 0; tryDock(); }); }
    }, { capture: true, passive: true });

    /* ---------- First screen: hero plus the whole logo bar ----------
       Round 6: the hero runs up under the announcement bar and the header (margin-top is minus
       --srw-top, padding-top puts the copy back below them), and its min-height is 100svh minus the
       logo bar (--srw-bar), so the bar's bottom edge lands inside the first screen. --srw-top is the
       height of everything in flow above <main> (the bar and the header), --srw-bar the logo bar's
       height, --srw-copy how far the copy reaches up from the hero's bottom (the phone gradient is
       sized to it). The CSS carries defaults; this replaces them with the real numbers, on load and
       on width change only, so a phone's toolbar sliding away never resizes the hero mid-scroll. */
    var heroEl = root.querySelector('.srw-cine'), barEl = root.querySelector('.sr-logobar'), fitW = 0;
    var mainEl = root.querySelector('main');
    function fit(force) {
      if (!heroEl || !barEl || (!force && window.innerWidth === fitW)) { return; }
      fitW = window.innerWidth;
      var top = 0, el = mainEl ? mainEl.previousElementSibling : null;
      for (; el; el = el.previousElementSibling) {
        var cs = getComputedStyle(el);
        if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') { continue; }
        top += el.getBoundingClientRect().height;
      }
      var bar = barEl.getBoundingClientRect().height;
      if (top >= 0 && top < 400) { root.style.setProperty('--srw-top', Math.ceil(top) + 'px'); }
      if (bar > 20 && bar < 400) { root.style.setProperty('--srw-bar', Math.ceil(bar) + 'px'); }
      var copy = heroEl.querySelector('.srw-cine__content');
      if (copy) {
        var hb = heroEl.getBoundingClientRect().bottom, ct = copy.getBoundingClientRect().top;
        if (hb - ct > 40) { root.style.setProperty('--srw-copy', Math.round(hb - ct) + 'px'); }
      }
    }
    fit(true);
    window.addEventListener('load', function () { fit(true); });
    window.addEventListener('resize', function () { fit(false); }, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { fit(true); }); }

    /* ---------- Hero quotes (Buyback, 2026-10-24) ----------
       On phones the two client quotes are one swiped row. While the row actually scrolls it takes a
       Tab stop, so keyboard users can reach the second quote; on wider screens it is a plain row. */
    var quotes = root.querySelector('.srw-cine__quotes');
    function quotesTab() {
      if (!quotes) { return; }
      if (quotes.scrollWidth > quotes.clientWidth + 2) { quotes.setAttribute('tabindex', '0'); }
      else { quotes.removeAttribute('tabindex'); }
    }
    quotesTab();
    window.addEventListener('resize', quotesTab, { passive: true });

    /* ---------- Header: transparent over the film at the top, solid once scrolled ---------- */
    var wrapEl = document.querySelector('.page-wrapper'), solid = null, hf = 0;
    function head() {
      hf = 0;
      var y = Math.max(window.pageYOffset || 0, wrapEl ? wrapEl.scrollTop : 0);
      var s = y > 56;
      if (s !== solid) { solid = s; root.classList.toggle('srw-head-solid', s); }
    }
    head();
    document.addEventListener('scroll', function () { if (!hf) { hf = requestAnimationFrame(head); } }, { capture: true, passive: true });

    var v = root.querySelector('.srw-cine__video');
    if (!v) { return; }
    var btn = root.querySelector('.srw-cine__toggle');
    var save = navigator.connection && navigator.connection.saveData;
    var small = window.matchMedia('(max-width: 760px)').matches;
    if (reduce.matches || save) { return; }
    v.muted = true;
    v.src = small ? v.getAttribute('data-src-sm') : v.getAttribute('data-src-lg');
    /* the film fades in over its <img> poster once it is really painting frames; if autoplay is
       refused (Low Power Mode) it never does, and the poster simply stays */
    v.addEventListener('playing', function on() { v.classList.add('is-on'); v.removeEventListener('playing', on); });
    v.preload = 'auto';
    var userPaused = false;

    /* ---------- One reel per visit (rotate on refresh, Will 2026-10-24) ----------
       The inline script after the hero already chose this visit's reel and set its sources, poster
       and credit. The film simply loops for the whole visit: there is no hand-over between reels, so
       nothing changes under the visitor while they read. */
    v.loop = true;
    function setBtn(paused) {
      if (!btn) { return; }
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play the film' : 'Pause the film');
    }
    function play() {
      var p = v.play();
      if (p && p.catch) { p.catch(function () { setBtn(true); }); }
      setBtn(false);
    }
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); setBtn(true); }
      });
    }
    /* A rect check on scroll rather than an IntersectionObserver alone: on this theme the page
       can scroll inside .page-wrapper, so scroll events are captured from any element. */
    function check() {
      var r = v.getBoundingClientRect();
      if (!r.height) { return; }
      var seen = (Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0)) / r.height;
      if (seen >= .15) { if (!userPaused && v.paused) { play(); } }
      else if (!v.paused) { v.pause(); }
    }
    var f = 0;
    function sched() { if (!f) { f = requestAnimationFrame(function () { f = 0; check(); }); } }
    document.addEventListener('scroll', sched, { capture: true, passive: true });
    window.addEventListener('resize', sched, { passive: true });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { sched(); } });
    v.addEventListener('loadeddata', check);
    check();
    reduce.addEventListener('change', function () { if (reduce.matches) { userPaused = true; v.pause(); setBtn(true); } });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
